export default {
    top: [
        {
            id: 'cctvHeader',
            header: 'CCTV'
        },
        {
            id: 'cctvItem',
            icon: 'assignment',
            title: 'CCTV',
            path: '/cctv'
        },
        {
            id: 'divider',
            divider: true,
            inset: true
        },
        {
            id: 'nodeInspectionsHeader',
            header: 'Node Inspections'
        },
        {
            id: 'wasteWaterItem',
            icon: 'assignment',
            title: 'Wastewater',
            path: '/wastewater'
        },
        {
            id: 'stormWaterItem',
            icon: 'assignment',
            title: 'Stormwater',
            path: '/stormwater'
        },
        {
            id: 'waterSupplyItem',
            icon: 'assignment',
            title: 'Water Supply',
            path: '/watersupply'
        }
    ],
    bottom: [
        {
            id: 'home',
            icon: 'home',
            title: 'Home',
            path: process.env.VUE_APP_RETICMANAGER_HOME
        }
    ]
}
